import { lazyLoad } from 'utils/loadable';

export const NetworkErrorLoadable = lazyLoad(
  () => import('./NetworkError'),
  module => module.NetworkError,
);
